/**
 * Tracks the clip a user most recently opened to edit, per story, so the
 * Content Studio "Edit Video" button can reopen it. Persisted in localStorage
 * because it must survive Content Studio ⇄ Creator Studio navigation (which
 * remounts components). Best-effort: degrades silently when storage is
 * unavailable. Timestamp-based recency is an unreliable proxy for "last used"
 * since many clips carry no save/publish timestamps, so we record explicit
 * opens instead.
 */

const keyFor = (storyId: string) => `arbor:lastEditedClip:${storyId}`;

export function recordLastEditedClip(
  storyId: string | undefined | null,
  clipId: string | undefined | null,
): void {
  if (!storyId || !clipId) return;
  try {
    localStorage.setItem(keyFor(storyId), clipId);
  } catch {
    // localStorage unavailable / quota — last-used tracking is best-effort.
  }
}

export function getLastEditedClip(
  storyId: string | undefined | null,
): string | null {
  if (!storyId) return null;
  try {
    return localStorage.getItem(keyFor(storyId));
  } catch {
    return null;
  }
}
